declare const __APP_VERSION__: string | undefined

/** The version this bundle was built as (see `define` in vite.config.ts); `dev` outside a Vite build. */
export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'dev'

/** How often an open tab asks whether a new version has been released. */
export const VERSION_POLL_MS = 5 * 60 * 1000
